
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/DateTimeUtils";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import HttpManager from "../../utils/HttpManager";
import TrialTranscriptionModal from "../TrialTranscriptionModal";

function GetActiveSubscriptions() {
    const navigate = useNavigate();
    const [subscriptions, setSubscriptions] = useState([]);

    const [loading, setLoading] = useState(true); // Add loading state
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        // Fetch subscription data from the server
        async function fetchSubscriptions() {
            try {
                const response = await new HttpManager(navigate).get("/Subscription/GetAll");
                // console.log("Subscriptions:", response);
                setSubscriptions(response);
                localStorage.setItem("UserSubscriptions", JSON.stringify(response))
            } catch (error) {
                console.error("Error fetching subscriptions:", error);
            } finally {
                setTimeout(() => setLoading(false) // Mark loading complete
                    , 3000);
            }
        }

        fetchSubscriptions();
    }, []);
    return (
        <>
            <div className="row  row-cols-2 row-cols-lg-2 border-bottom">

                <h2 className="pb-2 float-start text-start">
                    Active Subscriptions
                </h2>
                <h4 className="pb-2 float-end text-end  text-primary" style={{ cursor: "pointer" }} >
                    <button type="button" className="btn btn-outline-primary btn-lg px-4" onClick={() => setShowModal(true)}>Demo</button>
                </h4>
            </div>
            {
                loading ?
                    <ActiveSubscriptionSkeletonCard /> :
                    (subscriptions === null || subscriptions === undefined || subscriptions.length === 0) ?
                        <div className="row g-4 py-5 row-cols-1 row-cols-lg-1">
                            <div className="text-center">
                                <h3 className="text-body-emphasis">No Active Subscriptions</h3>
                                <p className="text-body-secondary">You don't have any active subscriptions. Please subscribe to a plan to use the service.</p>
                                <Link to="/Pricing" className="btn btn-primary">Checkout Subscription</Link>
                            </div>
                        </div> :

                        (
                            <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 g-2">
                                {
                                    subscriptions.map((subscription, index) => (
                                        <GetActiveSubscriptionCard SubscriptionData={subscription} />
                                    ))
                                }
                            </div>
                        )
            }
            {
                showModal && (<TrialTranscriptionModal setShowModal={setShowModal} />)
            }
        </>
    )

}

function GetActiveSubscriptionCard({ SubscriptionData }) {
    const navigate = useNavigate();

    console.log("SubscriptionName: ", SubscriptionData.SubscriptionName);
    return (
        <div className="feature col mt-5">
            <div class="card shadow-sm">

                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 mx-auto ">{SubscriptionData.SubscriptionName}</h5>
                    {/* <span className="d-flex align-items-center" style={{cursor:"pointer"}} onClick={() => navigate("/Usage/"+SubscriptionData.UserSubscriptionID,) }>
                        <i class="fa fa-area-chart text-primary me-2"> </i><small> View Usage</small>
                    </span> */}
                </div>
                <div class="card-body">
                    {/* <h3 className="card-title fs-2 text-body-emphasis">{SubscriptionData.SubscriptionData.SubscriptionName}</h3> */}
                    <ul class="mt-1 mb-0">
                        <li className="text-body-secondary">{new Intl.NumberFormat('en-IN').format(SubscriptionData.TotalCredits)} {SubscriptionData.CreditType} included</li>
                        <li className="text-body-secondary">₹{SubscriptionData.PerCreditPrice}/{SubscriptionData.CreditType}</li>
                        <li className="text-body-secondary">Max 15 sec per audio clip</li>
                        {/*<li className="text-body-secondary"> <strong className="text-inf">₹ {SubscriptionData.PerCreditPrice * SubscriptionData.TotalCredits}/month</strong></li> */}
                        <li className="text-body-secondary">Validity: <strong className="text-success">{formatDate(SubscriptionData.ExpiryDate)}</strong></li>
                        <li className="text-body-secondary">Auto Renew: <strong className="text-danger">Off</strong></li>
                        <br />
                    </ul>
                </div>
                <div class="card-footer text-body-secondary px-3 py-3 text-center">
                    <span className="text-primary">Subscription Key:</span><br /><strong>{SubscriptionData.SubscriptionKey}</strong>
                </div>
            </div>
        </div>
    );
}

function ActiveSubscriptionSkeletonCard() {
    return (
        <div className="feature col-3 mt-5">
            <div class="card shadow-sm">
                <h5 class="card-header text-center placeholder-glow">
                    <span className="placeholder col-5"></span>
                </h5>
                <div class="card-body placeholder-glow">
                    <ul class="list-unstyled mt-1 mb-0">
                        <li className="placeholder col-5"></li>
                        <br />
                        <li className="placeholder col-8"></li>
                        <br />
                        <li className="placeholder col-10"></li>
                        <br />
                    </ul>
                </div>
                <div class="card-footer text-body-secondary px-3 py-3 text-center col placeholder-glow">
                    <span className="text-primary placeholder col-6"></span><br /><strong className=" placeholder col-8"></strong>
                </div>
            </div>
        </div>
    );
}

export default GetActiveSubscriptions;